import { decode } from 'html-entities';
import removeMarkdown from '../../esm/lib/removeMarkdown.js';
import removeEmoji from './removeEmoji.js';

/**
 * Shared markdown / emoji / character cleanup for S3 audio scripts and JiT narration.
 * S3 createAudioScript usually has no ^ delimiters (DOM render → HTML → markdown);
 * JiT reads raw YAML, so ^…^ is stripped here explicitly.
 */
export default function stripNarrationText(input) {
  let text = String(input ?? '');
  text = decode(text);
  text = removeMarkdown(text);
  text = removeEmoji(text);
  text = text.replace(/\u00A0/g, ' ').replace(/\u202f/g, ' ');
  text = text.replace(/\^([^^]*?)\^/g, '$1');
  text = text.replaceAll('*', '').replaceAll('_', '').replaceAll('\\', '');
  return text.trim();
}
